import client from "./axiosConfig";

export const getAttendanceList = (params) => {
  const config = {
    url: "/attendance/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const markAttenadance = (data) => {
  const config = {
    url: "/attendance/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const backDated = (data) => {
  const config = {
    url: "/attendance/backdated/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const reviewAttendance = (id, data) => {
  const config = {
    url: `/attendance/review/${id}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getDetailedViewById = (id) => {
  const config = {
    url: `/attendance/${id}`,
    method: "GET"
  }
  const response = client(config);
  return response;
}

export const getBackdatedPermissions = (params) => {
  const config = {
    url: "/attendance/backdated-permissions/",
    method: "GET",
    params,
  };
  return client(config);
};

export const createBackdatedPermission = (data) => {
  const config = {
    url: "/attendance/backdated-permissions/",
    method: "POST",
    data,
  };
  return client(config);
};

export const deleteBackdatedPermission = (id) => {
  const config = {
    url: `/attendance/backdated-permissions/${id}/`,
    method: "DELETE",
  };
  return client(config);
};
